import '../styles/App.css';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useState, useRef, useEffect, useMemo } from "react"
import Studies from "./Studies"
import Paper from "./Paper"
import { ConfigProvider } from "antd";
import { supabase } from '../supabase';
 import Login from "./Auth.js"
 import AppLayout from "./AppLayout.js"
 import AuthLayout from "./AuthLayout.js"
import HomeLayout from "./HomeLayout.js"
 import NotFound from "./NotFound.js"
 import AccountPage from "./Account.js"
 import MediaPage from "./Media.js"
 import LandingPage from "./Landing.js"
 import AboutPage from "./About.js"
 import HowItWorksPage from "./HowItWorks.js"
 import { Analytics } from "@vercel/analytics/react"

function App() {
  const location = useLocation();
  const isAuthPage = location.pathname === "/auth";

  const [open, setopen] = useState(!isAuthPage)
  const [changingOpen, setChangingOpen] = useState(false)

  const [session, setSession] = useState(null)

  const [profile, setProfile] = useState(null)

  // Fetch user role when session changes
  useEffect(() => {
    const fetchProfile = async () => {
      if (session?.user?.id) {
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', session.user.id)
          .single();

        if (error) {
          console.error('Error fetching user role:', error);
          setProfile(null);
        } else {
          setProfile(data);
        }
      } else {
        setProfile(null);
      }
    };

    fetchProfile();
  }, [session]);

  const isAdmin = useMemo(() => {
    return profile?.admin
  }, [profile])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
    return () => subscription.unsubscribe()
  }, [])  

  useEffect(() => {
    setChangingOpen(true)

    const timer = setTimeout(() => {
      setChangingOpen(false)
    }, 400)

    return () => clearTimeout(timer)
  }, [open])

  useEffect(() => {
    const el = document.querySelector(".hidescroll"); // or use a ref
  if (!el) return;

  const handleScroll = () => {
    // scroll handling here if needed
  };

  el.addEventListener("scroll", handleScroll);
  return () => el.removeEventListener("scroll", handleScroll);
}, []);

  const ref = useRef(null);                        // 1. Create a ref to access the DOM element
      const [narrow, setNarrow] = useState(false); // 2. Track whether width is < 500px
  
      useEffect(() => {
          const el = ref.current;                        // 3. Get the DOM node
          if (!el) return;
  
          const observer = new ResizeObserver(([entry]) => {
              const width = entry.contentRect.width;       // 4. Get the element's rendered width
              // setNarrow(width <= 949);                    // 5. Set state if width < 500
              setNarrow(width <= 800);
          });
  
          observer.observe(el);                          // 6. Start observing the element
  
          return () => observer.disconnect();            // 7. Clean up on unmount
      }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Slider: {
            handleLineWidth: 1,
            handleLineWidthHover: 1,
            handleColor: "#0077b6",
            colorPrimaryBorderHover: "#0077b6",
            handleActiveColor: '#0077b6',
            handleSizeHover: 11,
            handleSize: 11,
            trackBg: "#0077b6",
            trackHoverBg: "#0077b6",
            handleActiveOutlineColor: "transparent",
            railHoverBg: "rgba(0,0,0,0.04)",
            dotActiveBorderColor: "#0077b6"
            }
        },
      }}
    >

    <Analytics />


      <Routes>

      <Route element={<HomeLayout />}>
        <Route path='/' element={<LandingPage />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/how-it-works' element={<HowItWorksPage />} />
      </Route>

      <Route element={<AuthLayout />}>
        <Route 
  path="/auth" 
  element={
    !session || new URLSearchParams(window.location.search).get('type') === 'recovery'
      ? <Login /> 
      : <Navigate to="/documents" replace />
  } 
/>

        
        {/* <Route path="/auth" element={<Login />} /> */}
      </Route>

      {/* APP ROUTES */}
      <Route element={
        session
          ? <AppLayout session={session} open={open} setopen={setopen} ref={ref} />
          : <Navigate to="/auth" replace />
      }>
        <Route path='/documents' element={<Studies open={changingOpen} narrow={narrow} setNarrow={setNarrow} isAdmin={isAdmin} />} />
        <Route path='/media' element={<MediaPage />} />
        <Route path='/account' element={<AccountPage profile={profile} session={session}/>} />
        <Route path='/documents/:id' element={<Paper isAdmin={isAdmin} />}/>
        <Route path="*" element={<NotFound session={session} />} />
      </Route>
    </Routes>
    
    </ConfigProvider>
  );
}

export default App;
